import { Ad, Ag, Ai, Ao, As, Au } from "../../_components/Imagepath";

export default {
    Data: [
        {
          Id: 1,
          key: 1,
          CountryCode: "AS",
          CountryId: 684,
          Name: "American Samoa(+684)",
          img:As,
          StateName:"Swains Island",
          CityName:"Gandzasar",
          Action: ""
        },
        {
          Id: 2,
          key: 2,
          CountryCode: "AD",
          CountryId: 376,
          Name: "Andorra (+376)",
          img:Ad,
          StateName:"Andorra la Vella",
          CityName:"Escaldes-Engordany",
          Action: ""
        },
        {
          Id: 3,
          key: 3,
          CountryCode: "AO",
          CountryId: 244,
          Name: "Angola (+244)",
          img:Ao,
          StateName:"Benguela",
          CityName:"Chissamba",
          Action: ""
        },
        {
          Id: 4,
          key: 4,
          CountryCode: "AI",
          CountryId: 1264,
          Name: "Anguilla (+1264)",
          img:Ai,
          StateName:"The Valley",
          CityName:"LLLinois",
          Action: ""
        },
        {
          Id: 5,
          key:5,
          CountryCode: "AQ",
          CountryId: 672,
          Name: "Antigua & Barbuda (+1268)",
          img:Ag,
          StateName:"Victoria Land",
          CityName:"Maplewood",
          Action: ""
        },
        {
          Id: 6,
          key: 6,
          CountryCode: "AQ",
          CountryId: 1268,
          Name: "Australia",
          img:Au,
          StateName:"Saint Paul",
          CityName:"Sydney",
          Action: ""
        },
        {
          Id: 7,
          key:7,
          CountryCode: "AS",
          CountryId: 684,
          Name: "American Samoa(+684)",
          CityName:"Gandzasar",
          StateName:"Swains Island",
          img:As,
          Action: ""
        },
        {
          Id: 8,
          key: 8,
          CountryCode: "AD",
          CountryId: 376,
          Name: "Andorra (+376)",
          CityName:"Escaldes-Engordany",
          StateName:"Andorra la Vella",
          img:Ad,
          Action: ""
        },
        {
          Id: 9,
          key: 9,
          CountryCode: "AO",
          CountryId: 244,
          Name: "Angola (+244)",
          CityName:"Chissamba",
          StateName:"Benguela",
          img:Ao,
          Action: ""
        }
       ]
}